import React from 'react';
import { Create } from 'react-admin';
import Form from './detail/Form';

export default (props) => {
  return (
    <Create {...props}>
      <Form {...props} />
    </Create>
  );
};
